import React from 'react';
import { TourGuideParagraph } from '../TourGuideParagaph';

export const Segment3 = () => (
    <TourGuideParagraph>
        THE PEARL™ is a data-safe cry if you need to, laugh if you want to, inclusive and anonymous space designed for private, judgement-free, full-spectrum introspection, self-expression, discovery and healing.
    </TourGuideParagraph>
);
